import * as angular from 'angular';
import QRCode = require('qrcode-svg');
import { EnumService } from './enum.service';
import { TransferFileService } from './transferFile.service';

export class QRCodeService {
  public static $inject = ['transferFileService', 'enumService'];

  constructor(public transferFileService: TransferFileService, private enumService: EnumService) {}

  public getQrCode(link: string, readingLocation: string) {
    const qrCode = new QRCode({
      content: link,
      padding: 4,
      width: 500,
      height: 500,
      color: '#000000',
      background: '#ffffff',
      ecl: 'M',
      join: true,
      container: 'svg-viewbox'
    });
    const svg = qrCode.svg();
    this.transferFileService.transferFile(svg, `${readingLocation}__QR.svg`, this.enumService.ExportFileType.SVG);
  }
}

angular
  .module('app.common')
  .service('qrCodeService', QRCodeService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/services/qr-code.service.ts